import React, { useEffect } from 'react';

/**
 * Google AdSense Component
 *
 * How to use:
 * 1. Sign up for Google AdSense at https://www.google.com/adsense
 * 2. Get your publisher ID (ca-pub-XXXXXXXXXXXXXXXX)
 * 3. Create an ad unit and get the ad slot ID
 * 4. Add your AdSense code to public/index.html
 * 5. Use this component with your client and slot IDs
 */
const AdSense = ({
  client = 'ca-pub-6089581272933355',
  slot = '5107198814', // TraderBook Feed Ad
  format = 'auto',
  responsive = 'true',
  style = {}
}) => {
  useEffect(() => {
    try {
      // Push ad to AdSense
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div className="adsense-container w-full" style={style}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', ...style }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

export default AdSense;
